module.exports = __webpack_public_path__ + "static/ha2-539c93e7001c9fa4f922dead0cf44f90.jpg";